import { useFormContext, useWatch } from 'react-hook-form';
import { twJoin } from 'tailwind-merge';

import { StudioPermissions } from '@/enums/VersioningStatus';
import { scrollBarYClassName } from '@/utils/scrollBarClassName';
import { CourseStudioFormFields } from '../CourseStudio.hooks';
import { CourseStudioProps } from '../info/CourseStudioInfo.hooks';
import DirectLessonDetail from './DirectLessonDetail';

type Props = CourseStudioProps & {
  studioPermissions: StudioPermissions;
  coursePathId?: number;
};

export default function CourseStudioLessonsDetailsStep(props: Props) {
  const { control } = useFormContext<CourseStudioFormFields>();

  const lessons = useWatch({
    control,
    name: 'directLessons',
  });

  return (
    <article className="flex flex-col gap-2.5">
      <ul
        className={twJoin(
          'flex flex-col gap-2.5 max-h-[calc(100vh-20rem)]',
          scrollBarYClassName,
        )}
      >
        {lessons?.map((lesson, lessonIndex) => (
          <DirectLessonDetail
            key={lesson.id || lesson.tempId}
            lesson={lesson}
            lessonIndex={lessonIndex}
            globalLessonIndex={lessonIndex}
            studioPermissions={props.studioPermissions}
            coursePathId={props.coursePathId}
            loading={props.loading}
          />
        ))}
      </ul>
    </article>
  );
}
